import { useNavigate } from 'react-router-dom';
import { ShieldOff } from 'lucide-react';

import { useT } from '../i18n';

/** Màn báo không đủ quyền (§4.5). */
export function ForbiddenView() {
  const navigate = useNavigate();
  const { t } = useT();

  return (
    <div className="flex h-full min-h-[60vh] flex-col items-center justify-center px-6 text-center">
      <div className="mb-5 flex h-16 w-16 items-center justify-center rounded-full bg-danger-50">
        <ShieldOff size={32} className="text-danger-500" />
      </div>
      <h1 className="mb-2 text-xl font-bold text-content-primary">
        {t('chan.khongCoQuyenTieuDe')}
      </h1>
      <p className="mb-6 max-w-sm text-sm text-content-secondary">
        {t('chan.khongCoQuyenMo')}
      </p>
      <button
        type="button"
        onClick={() => navigate(-1)}
        className="rounded-lg bg-primary-600 px-4 py-2 text-sm font-medium text-white transition-colors hover:bg-primary-700"
      >
        {t('chung.quayLai')}
      </button>
    </div>
  );
}
